$(document).ready(function(e){

    let $body = $('body');

    window.Echo.channel('wizard')
        .listen('WizardEvent', (payload) => {
            handleWizardPayload(payload);
        });

    function handleWizardPayload(payload){

        let tenant = document.head.querySelector('meta[name="tenant"]').content,
            user_id = document.head.querySelector('meta[name="user_id"]').content;

        if(payload.user_id === parseInt(user_id) && payload.tenant === tenant && payload.step){
            $('.wizard-sidebar').css('width', '350px');
            $('.wizard-section').find(`.step[data-action=${payload.step}]`).trigger('click');
        }
    }

    $('.close-wizard-modal').on('click', function(e){
        $.ajax({
            type : "POST",
            url : '/wizard/flash',
            data : {
                overlay : ''
            },
            success : function(res){
                if(res){
                    window.location = '/';
                }
            }
        })
    });

    $('.open-help').on('click', function(){
        $('.wizard-sidebar').addClass('expanded');

        $.ajax({
            type : "POST",
            url : '/wizard/show',
            data : {
                show : 1
            }
        });
    });

    $('.close-wizard').on('click', function(e){
        $('.wizard-sidebar').removeClass('expanded');

        $.ajax({
            type : "POST",
            url : '/wizard/show',
            data : {
                show : 0
            }
        });

        if($(this).hasClass('first-login')){
            $.ajax({
                type : "POST",
                url : '/wizard/stop',
            });
        }
    });

    $('.wizard-section .step').on('click', function(e){
        e.preventDefault();

        let action = $(this).attr('data-action'),
            step = $(this).attr('data-step'),
            section = $(this).attr('data-section');

        switch(action){
            case 'getting_started':
                showGetStarted();
                break;
            case 'list_page':
                showListPage();
                break;
            case 'menu':
                showMenu();
                // markSectionComplete(action, section, step);
                break;
            case 'calendar':
                showCalendar();
                break;
            case 'compose-email':
                showComposeEmail();
                break;
            case 'notification':
                showNotifications();
                break;
            case 'user-profile-setup':
                showUserProfile();
                break;
            case 'company-information':
                showCompanyInformation();
                break;
            case 'invite-colleagues':
                showInviteColleagues();
                break;
            case 'create-customer':
                showCreateCustomer();
                break;
            case 'create-product':
                showCreateProduct();
                break;
            case 'create-quotation':
                showCreateQuotation();
                break;
            case 'create-tasks':
                showCreateTask();
                break;
        }
    });

    $('#notifications-btn').on('click', function(e){
        if($(this).hasClass('sidebar-animate')){
            markSectionComplete('notification', 1, 4);
        }
    });

    $body.on('click', '#wizard-action', function(e){
        e.preventDefault();
        let action = $(this).attr('data-action');
        let mark_step = $(this).attr('data-mark-step');

        console.log(action, mark_step);

        if(action === 'close_modal'){
            $('#wizard-modal').modal('hide');
        }

        if(mark_step.length){
            mark_step = JSON.parse(mark_step);
            markSectionComplete(mark_step.action, mark_step.section, mark_step.step);
        }

        if(action === 'open_calendar'){
            let url = $('.sidebar-calendar-icon').attr('href');
            $.ajax({
                type : "POST",
                url : '/wizard/flash',
                data : {
                    overlay : 'create_event'
                },
                success : function(res){
                    if(res){
                        window.location = url;
                    }
                }
            })
        }

        if(action === 'create_task'){
            let url = $('#sidebar').find(`.md-button[data-table-name="Tasks"]`).siblings('.sidebar-create-btn').attr('href');

            $.ajax({
                type : "POST",
                url : '/wizard/flash',
                data : {
                    overlay : 'understood_event'
                },
                success : function(res){
                    if(res){
                        window.location = url;
                    }
                }
            })
        }

        if(action === 'compose_email'){
            $.ajax({
                type : "POST",
                url : '/wizard/flash',
                data : {
                    overlay : 'email_accounts'
                },
                success : function(res){
                    if(res){
                        window.location = '/emails';
                    }
                }
            })
        }

        if(action === 'open_compose_form'){
            $('#wizard-modal').modal('hide');
            $('.compose-email-btn').trigger('click');
        }

        if(action === 'add_email'){
            $('#wizard-modal').modal('hide');
            $('.add-email-btn').trigger('click');

            $.ajax({
                type : "POST",
                url : '/wizard/flash',
                data : {
                    overlay : 'redirect_email'
                },
                success : function(res){}
            })
        }

        if(action === 'show_profile_settings'){
            $('#wizard-modal').modal('hide');
            $('#edit-profile').trigger('click');
        }

        if(action === 'invite_colleagues'){
            $('#wizard-modal').modal('hide');
            $('#invite-colleague').trigger('click');
        }

        if(action === 'understood_notifications'){
            $('#wizard-modal').modal('hide');
            setTimeout(function(){ $('#notifications-btn').click()}, 0);
        }

        if(action === 'show_notifications'){
            $('#wizard-modal').modal('hide');
            setTimeout(function(){ $('#notifications-btn').click()}, 100);

            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'notifications_2'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }

        if(action === 'open_list_modal'){
            $('#wizard-modal').modal('hide');
            markSectionComplete('getting_started', 0, 0);
            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'list_page'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }

        if(action === 'create_company'){
            let url = $('#sidebar').find(`.md-button[data-table-name="Companies"]`).siblings('.sidebar-create-btn').attr('href');

            $.ajax({
                type : "POST",
                url : '/wizard/flash',
                data : {
                    overlay : 'create_company_2'
                },
                success : function(res){
                    if(res){
                        window.location = url;
                    }
                }
            });
        }

        if(action === 'add_contact_overlay'){
            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'add_contact_modal'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }

        if(action === 'create_product'){
            let url = $('#sidebar').find(`.md-button[data-table-name="Products"]`).siblings('.sidebar-create-btn').attr('href');

            $.ajax({
                type : "POST",
                url : '/wizard/flash',
                data : {
                    overlay : 'create_product_2'
                },
                success : function(res){
                    if(res){
                        window.location = url;
                    }
                }
            });
        }

        if(action === 'create_quotation'){
            let url = $('#sidebar').find(`.md-button[data-table-name="Quotations"]`).siblings('.sidebar-create-btn').attr('href');

            $.ajax({
                type : "POST",
                url : '/wizard/flash',
                data : {
                    overlay : 'create_quotation_2'
                },
                success : function(res){
                    if(res){
                        window.location = url;
                    }
                }
            });
        }

        if(action === 'add_product'){
            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'add_product_modal'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }

        if(action === 'print_preview'){
            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'print_preview_modal'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }

        if(action === 'send_email'){
            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'send_email_modal'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }

        if(action === 'create_task_2'){
            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'create_task_modal'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }

        if(action === 'view_tasks'){
            setTimeout(function(){
                $.ajax({
                    type : "POST",
                    url : '/wizard/content',
                    data : {
                        overlay : 'view_tasks_modal'
                    },
                    success : function(res){
                        if(res){
                            $('.wizard-content').empty().html(res);
                            $('#wizard-modal').modal('show');
                        }
                    }
                })
            }, 400);
        }
    });
});

function showListPage(){
    $.ajax({
        type : "POST",
        url : '/wizard/content',
        data : {
            overlay : 'list_page'
        },
        success : function(res){
            if(res){
                $('.wizard-content').empty().html(res);
                $('#wizard-modal').modal('show');
            }
        }
    })
}

function showGetStarted(){
    $.ajax({
        type : "POST",
        url : '/wizard/flash',
        data : {
            overlay : 'getting_started'
        },
        success : function(res){
            if(res){
                window.location = '/';
            }
        }
    })
}

function showMenu(){

    $('#wizard-action').attr('data-action', 'close_modal');

    $.ajax({
        type : "POST",
        url : '/wizard/flash',
        data : {
            overlay : 'menu'
        },
        success : function(res){
            if(res){
                window.location = '/menu';
            }
        }
    })
    // $('#sidebar').addClass('expanded');
}

function showCalendar(){

    $.ajax({
        type : "POST",
        url : '/wizard/content',
        data : {
            overlay : 'calendar'
        },
        success : function(res){
            if(res){
                $('.wizard-content').empty().html(res);
                $('#wizard-modal').modal('show');
            }
        }
    })
    // $('#sidebar').addClass('expanded');
    // hideHighlightedContent();
    // $('.sidebar-calendar-icon').addClass('sidebar-animate');
}

function showComposeEmail(){

    $.ajax({
        type : "POST",
        url : '/wizard/content',
        data : {
            overlay : 'compose_email'
        },
        success : function(res){
            if(res){
                $('.wizard-content').empty().html(res);
                $('#wizard-modal').modal('show');
            }
        }
    })

    // $('#sidebar').addClass('expanded');
    // hideHighlightedContent();
    // $('.sidebar-compose-email').addClass('sidebar-animate');
}

function showNotifications(){

    $.ajax({
        type : "POST",
        url : '/wizard/content',
        data : {
            overlay : 'notifications'
        },
        success : function(res){
            if(res){
                $('.wizard-content').empty().html(res);
                $('#wizard-modal').modal('show');
            }
        }
    })
    // hideHighlightedContent();
    // $("#notifications-btn").addClass('sidebar-animate');
}

function showUserProfile(){
    $.ajax({
        type : "POST",
        url : '/wizard/content',
        data : {
            overlay : 'profile_settings'
        },
        success : function(res){
            if(res){
                $('.wizard-content').empty().html(res);
                $('#wizard-modal').modal('show');
            }
        }
    })
    // $('#edit-profile').trigger('click');
}

function showCompanyInformation(){
    $.ajax({
        type : "POST",
        url : '/wizard/flash',
        data : {
            overlay : 'company_settings'
        },
        success : function(res){
            if(res){
                window.location = '/settings/company';
            }
        }
    })
}

function showInviteColleagues(){
    $.ajax({
        type : "POST",
        url : '/wizard/content',
        data : {
            overlay : 'invite_colleagues'
        },
        success : function(res){
            if(res){
                $('.wizard-content').empty().html(res);
                $('#wizard-modal').modal('show');
            }
        }
    })
    // $('#invite-colleague').trigger('click');
}

function showCreateCustomer(){

    let url = $('#sidebar').find(`.md-button[data-table-name="Companies"]`).attr('href');

    $.ajax({
        type : "POST",
        url : '/wizard/flash',
        data : {
            overlay : 'create_company'
        },
        success : function(res){
            if(res){
                window.location = url;
            }
        }
    });

    // $('#sidebar').addClass('expanded');
    // hideHighlightedContent();
    // $('#sidebar').find(`.md-button[data-table-name="Companies"]`).addClass('sidebar-animate')
}

function showCreateProduct(){

    let url = $('#sidebar').find(`.md-button[data-table-name="Products"]`).attr('href');

    $.ajax({
        type : "POST",
        url : '/wizard/flash',
        data : {
            overlay : 'create_product'
        },
        success : function(res){
            if(res){
                window.location = url;
            }
        }
    });

    // $('#sidebar').addClass('expanded');
    // hideHighlightedContent();
    // $('#sidebar').find(`.md-button[data-table-name="Products"]`).addClass('sidebar-animate');
}

function showCreateQuotation(){

    let url = $('#sidebar').find(`.md-button[data-table-name="Quotations"]`).attr('href');

    $.ajax({
        type : "POST",
        url : '/wizard/flash',
        data : {
            overlay : 'create_quotation'
        },
        success : function(res){
            if(res){
                window.location = url;
            }
        }
    });

    // $('#sidebar').addClass('expanded');
    // hideHighlightedContent();
    // $('#sidebar').find(`.md-button[data-table-id="8"]`).addClass('sidebar-animate');
}

function showCreateTask(){

    let url = $('#sidebar').find(`.md-button[data-table-name="Tasks"]`).attr('href');

    $.ajax({
        type : "POST",
        url : '/wizard/flash',
        data : {
            overlay : 'create_task'
        },
        success : function(res){
            if(res){
                window.location = url;
            }
        }
    });
    // $('#sidebar').addClass('expanded');
    // hideHighlightedContent();
    // $('#sidebar').find(`.md-button[data-table-name="Tasks"]`).addClass('sidebar-animate');
}

function hideHighlightedContent(){
    $('body').find('.sidebar-animate').removeClass('sidebar-animate');
}

function markSectionComplete(action, section, step){
    $.ajax({
        type : 'POST',
        url : '/wizard/done',
        data : {
            action, section, step
        },
        success : function(res){
            if(res){
                let $step = $(`.wizard-section .step[data-action="${action}"]`);
                $step.addClass('done');
            }
        }
    })
}